import Link from "next/link";
import Image from "next/image";
import useSWRImmutable from "swr/immutable";
import Loader from "./Loader";
import { getTachyonThumbnail } from "../helpers/tachyon";
import { ConvertDateToTimeSince } from "../helpers/util";
import styles from "../styles/ErrorPage.module.scss";

const cfUrl = process.env.API_CF_URL;
const ErrorPage = ({ graphics, errorMessage }) => {
  const loader = ({ src, width, quality }) => {
    return `${src}?w=${width}&q=${quality || 75}`;
  };

  const RenderFeed = () => {
    const fetcher = (url, body) =>
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body,
      }).then(async (res) => {
        return res.json();
      });

    const removeFeedsWithoutImages = (feeds) => {
      if (!feeds || feeds.length <= 0) return null;
      return feeds.filter((x) => x.image);
    };

    const { data: rawData, error } = useSWRImmutable(
      [
        `${cfUrl}/getRSS`,
        JSON.stringify({
          data: {
            type: "news",
            topic: "election",
          },
        }),
      ],
      fetcher,
      {
        refreshInterval: 0,
        shouldRetryOnError: true,
        errorRetryInterval: 1500,
        errorRetryCount: 1,
      }
    );
    const data = rawData?.result;

    if (!error && !data) return <Loader />;
    if (error) return <p>Something went wrong, Please try again later!</p>;

    let rssFeed = removeFeedsWithoutImages(data);
    (rssFeed || []).forEach((feed) => {
      if (feed.image) feed.cropImage = getTachyonThumbnail(feed.image);
    });

    return (
      <div className={styles.latestNewsWrapper}>
        {(rssFeed || []).slice(5).map((rss, i) => (
          <article key={i}>
            <Link href={rss.link} passHref>
              <a>
                <div className={styles.details}>
                  <p className={styles.category}>{rss.categories[0]}</p>
                  <h3 className={styles.latestNewsTitle}>{rss.title}</h3>
                  <p className={styles.pubDate}>
                    {ConvertDateToTimeSince(rss.pubDate)}
                  </p>
                </div>
                <div className={styles.details}>
                  {rss.cropImage && (
                    <Image
                      src={rss.cropImage}
                      alt={rssFeed?.title}
                      layout="responsive"
                      width={60}
                      height={60}
                    />
                  )}
                </div>
              </a>
            </Link>
          </article>
        ))}
      </div>
    );
  };

  return (
    <div className={styles.errorWrapper}>
      <div className={styles.errorGraphics}>
        <Image
          loader={loader}
          src={graphics}
          alt="error icon"
          layout="responsive"
        />
      </div>
      <p className={styles.errorMessage}>{errorMessage}</p>
      <Link href={`/`} passHref>
        <a className={styles.backBtn}>go back to election homepage</a>
      </Link>

      {RenderFeed()}
    </div>
  );
};

export default ErrorPage;
